var _defs, _circle, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassengerCargo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: #10b7cb;\n      }\n\n      .st2 {\n        fill: none;\n        stroke: #10b7cb;\n        stroke-width: 2.5px;\n      }\n\n      .st1 {\n        opacity: .2;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 65,
    cy: 65,
    r: 65
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 40.231,
    y: 28.244,
    width: 49.537,
    height: 13.619
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "58.646 14.441 71.354 14.441 74.189 28.244 55.811 28.244 58.646 14.441"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "65 62.725 28.254 65.746 39.589 112.75 90.411 112.75 101.746 65.746 65 62.725"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "35.076 65.185 35.076 41.863 94.924 41.863 94.924 65.185"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 65.008,
    y1: 49.145,
    x2: 65.01,
    y2: 71.54
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 74.189,
    y1: 27.52,
    x2: 87.791,
    y2: 41.122
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 65,
    y1: 28.463,
    x2: 78.337,
    y2: 41.801
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.013,96.092h-4.283v7.572h-5.278v-26.007h9.562c6.17,0,9.256,3.009,9.256,9.026,0,3.034-.785,5.36-2.354,6.979-1.566,1.619-3.869,2.429-6.902,2.429ZM51.729,91.579h4.245c2.626,0,3.938-1.632,3.938-4.896,0-1.606-.318-2.76-.955-3.461-.638-.701-1.633-1.052-2.983-1.052h-4.245v9.408Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.461,103.243c-2.703.587-5.138.88-7.305.88s-3.901-.268-5.201-.803c-1.301-.536-2.32-1.39-3.06-2.562-.74-1.173-1.25-2.55-1.53-4.131-.28-1.58-.42-3.569-.42-5.966,0-5.022.707-8.522,2.122-10.498s4.021-2.964,7.821-2.964c2.192,0,4.729.344,7.61,1.032l-.152,4.207c-2.524-.383-4.622-.574-6.292-.574s-2.862.224-3.575.67c-.715.446-1.243,1.294-1.588,2.543-.344,1.25-.516,3.379-.516,6.387s.35,5.094,1.052,6.253c.7,1.161,2.104,1.74,4.207,1.74s4.341-.178,6.712-.535l.114,4.321Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassengerCargo);
export default __webpack_public_path__ + "static/media/passenger_cargo.03080388957fadab7f1d8657691aae4c.svg";
export { ForwardRef as ReactComponent };